import { useRef } from 'react';
import {
  DrawerTooltipContainer,
  DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { ThreeDotsToggle } from 'src/v2/commonComponents/ThreeDotsToggle';
import { AdditionalToolbarButtons } from '../AdditionalToolbarButtons';
import styles from './EditorFormattingMenuControl.module.scss';

const anchorId = 'editor-formatting-menu-anchor';

export const EditorFormattingMenuControl = () => {
  const drawerRef = useRef<DrawerTooltipContainerRef>(null);

  return (
    <>
      <DrawerTooltipContainer
        ref={drawerRef}
        id={anchorId}
        place="bottom"
        offset={8}
        classNameTooltip={styles.tooltip}
        onlyTooltip
        ToggleButton={ThreeDotsToggle}
      >
        <div className={styles.container}>
          <AdditionalToolbarButtons drawerRef={drawerRef} />
        </div>
      </DrawerTooltipContainer>
    </>
  );
};
